export default "__VITE_ASSET__36c938fc__"